module.exports = __webpack_public_path__ + "img/Tree.d4de229a.jpg";